// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
import EndpointsTestingComponent from './endpointsTestingComponent'
import Loading from '../../components-lib/loading'
import ErrorMessage from '../../components-lib/errorMessage'
import Success from '../../components-lib/success'
import {useAxios} from '../../hooks/useAxios'
    export default
        function GetPaymentTokenTestingEndpoints(
        props
        )
        {
            const [{response: paymentToken, isLoading: paymentTokenLoading, error: paymentTokenError}, paymentTokenFetch, paymentTokenClear] = useAxios()
            const paymentTokenPost = 
                (paymentTokenParams, responseCallback, errorCallback, cancelCallback) => {
                    paymentTokenFetch({
                        url: `/Proxy/GetPaymentToken`,
                        data: paymentTokenParams,
                        method: "post",
                        responseCallback,
                        errorCallback,
                        cancelCallback
                    });
                }
            function mainRender() {
                return (
                    <div className='container-lg'>
                        <div className='display-4'>GetPaymentTokenTestingEndpoints</div>
                    </div>
                )
            }
            return (
                <>
                    {mainRender()}
                    {paymentTokenLoading && <Loading isSaving/>}
                    {paymentTokenError && <ErrorMessage error={paymentTokenError} fetchForInit={paymentTokenClear}/>}
                    {paymentToken && <Success/>}
                    <EndpointsTestingComponent
                        paymentToken={paymentToken}
                        onPaymentTokenPost={paymentTokenPost}
                        onPaymentTokenClear={paymentTokenClear}
                        {...props}
                    />
                </>
            )
        }
